import {
  START_LOADING,
  STOP_LOADING,
  GET_POLICY_SUCCESS,
  UPDATE_POLICY_SUCCESS,
  GET_POLICY_FAILURE,
  SAVE_POLICY_FAILURE,
  UPDATE_POLICY_FAILURE,
  DELETE_POLICY_SUCCESS,
  DELETE_POLICY_FAILURE
} from './actionTypes';
import { getDetailPolicy, savePolicy, getDetailPolicyPagination,
  savedCustomerPolicyList, getPolicyById,
  getSearchPolicyList, getPolicyPremiumDetailServices, getVehiclePremiumByPolicyId,
  getCoveragelisting, deleteVehicleService} from '../../services/policySevices';
import { updatePolicy } from '../../services/policySevices';
import { getAllPolicy, deleteDriverService, getPremiumVehiclesPageService } from '../../services/policySevices';
import { deletePolicyById } from '../../services/policySevices';
import { openSessionTimeoutModal } from './sessionTimeOutActions';

export const savePolicyAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await savePolicy(formData, token);
    if (response && typeof callbackfn === 'function') callbackfn(response);
    return response; // <-- return so callers can check status
  } catch (error) {
    dispatch({ type: SAVE_POLICY_FAILURE, payload: error || 'Save policy service failed. Please try again.' });
    throw error;
  } finally {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  }
};


export const updatePolicyAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await updatePolicy(formData, token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: UPDATE_POLICY_SUCCESS, payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: UPDATE_POLICY_FAILURE, payload: error || 'Update policy service failed. Please try again.' });
    }
  }
};

export const getAllPolicyAction= (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getAllPolicy(token,page,size);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: GET_POLICY_SUCCESS, payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: GET_POLICY_FAILURE, payload: error || 'All policy service failed. Please try again.' });
    }
  }
};

export const deletePolicyActionById = (quoteId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");

    const response= await deletePolicyById(quoteId,token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });


    // dispatch({ type: 'ALL_DRIVER_INFOS_SUCCESS', payload: response });
    dispatch({ type: DELETE_POLICY_SUCCESS, payload: quoteId });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: DELETE_POLICY_FAILURE, payload: error.message || 'All policy service failed. Please try again.' });
  }
};

export const getDetailPolicyAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'GET_DETAIL_POLICY' });
    const token = getState().auth.token || sessionStorage.getItem("token");

    // 👇 Make sure to pass page & size to the service
    const response = await getDetailPolicy(token, id, page, size);

    dispatch({ type: 'GET_DETAIL_POLICY_SUCCESS', payload: response });
    return response; // allows awaiting this call if needed
  } catch (error) {
    const msg = error?.message ?? String(error ?? '');
    if (msg.includes('403')) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({
        type: 'GET_DETAIL_POLICY_FAILURE',
        payload: msg || 'Policy service failed. Please try again.',
      });
    }
    throw error;
  } finally {
    dispatch({ type: STOP_LOADING, service: 'GET_DETAIL_POLICY' });
  }
};


export const getDetailPolicyPaginationAction =
  (id, { section = 'driver', page = 0, size = 5 } = {}) =>
  async (dispatch, getState) => {
    dispatch({ type: STOP_LOADING, service: 'GET_DETAIL_POLICY' });
    try {
      const token = getState().auth.token || sessionStorage.getItem('token');

      // 1) read last-known pagination for all sections
      const current = getState()?.policy?.pagination || {
        driver:      { page: 0, size: 5 },
        vehicle:     { page: 0, size: 5 },
        coverage:    { page: 0, size: 5 },
      };

      // 2) override only the active section
      const merged = {
        driver:   { ...current.driver },
        vehicle:  { ...current.vehicle },
        coverage: { ...current.coverage },
      };
      if (merged[section]) merged[section] = { page, size };

      // 3) call service with the merged map
      const response = await getDetailPolicyPagination({
        token,
        id,
        pagination: merged,      // <-- important
      });

      dispatch({
        type: 'GET_DETAIL_POLICY_SUCCESS',
        payload: response,
        meta: { section, page, size },  // reducer updates only that section
      });
      return response;
    } catch (error) {
      // ... your existing error handling ...
      throw error;
    } finally {
      dispatch({ type: STOP_LOADING, service: 'GET_DETAIL_POLICY' });
    }
  };

export const getPolicyVehiclesPageForPremium =
  (policyId, { page = 0, size = 5 } = {}) =>
  async (dispatch, getState) => {
    const token = getState().auth.token || sessionStorage.getItem("token");
    const state = getState();
    const current = state.policy.pagination || {
      driver: { page: 0, size: 5 },
      vehicle: { page: 0, size: 5 },
      coverage: { page: 0, size: 5 },
    };
    const merged = {
      // ...current,
      coverage: { page, size }, // overwrite coverage pagination
    };

    const res = await getDetailPolicyPagination({
      token,
      id: policyId,
      pagination: merged,
    });

    dispatch({
      type: "GET_PREMIUM_VEHICLES_SUCCESS",
      payload: res?.vehicles ?? {},
      meta: { page, size },
    });
  };


export const refreshVehiclesAndPremium = (policyIdArg) => async (dispatch, getState) => {
  const st = getState();
  const effectiveId = policyIdArg ?? st?.policy?.allDetailPolicy?.id ?? null;
  if (!effectiveId) return; // nothing to refresh yet

  // Keep each table on its current page/size
  const veh = st.policy?.allDetailPolicy?.vehicles;
  const vehiclePage = veh?.number ?? 0;
  const vehicleSize = veh?.size ?? 5;

  const prem = st.policy?.premiumVehicles;
  const premiumPage = prem?.number ?? 0;
  const premiumSize = prem?.size ?? 5;

  await Promise.all([
    // ✅ Vehicles section
    dispatch(
      getDetailPolicyPaginationAction(effectiveId, {
        section: "vehicle",
        page: vehiclePage,
        size: vehicleSize,
      })
    ),
    // ✅ Coverage (premium) section — same unified pagination action
    dispatch(
      getDetailPolicyPaginationAction(effectiveId, {
        section: "coverage",
        page: premiumPage,
        size: premiumSize,
      })
    ),
  ]);
};


export const getPolicyByIdAction= (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getPolicyById(token,id);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_POLICY_BY_ID_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_POLICY_BY_ID_FAILURE', payload: error || 'All policy service failed. Please try again.' });
    }
  }
};

export const getPolicySearchPolicyListAction= (policyNumber, page=0,size=5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getSearchPolicyList(token, policyNumber,page,size);

    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'SEARCH_POLICY_LIST_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'SEARCH_POLICY_LIST_FAILURE', payload: error || 'All policy service failed. Please try again.' });
  }
};

export const getPolicyPremiumDetails = (id) => async (dispatch, getState) => {
  try {
     dispatch({ type: STOP_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getPolicyPremiumDetailServices(token,id);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_POLICY_PREMIUM_DETAIL_SUCCESS', payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_POLICY_PREMIUM_DETAIL_FAILURE', payload: error || 'Policy premium service failed. Please try again.' });
    }
  }
};

export const getSavedCustomerList = (firstName, lastName, dateOfBirth, phoneNumber, callbackfn) => async (dispatch, getState) => {

  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await savedCustomerPolicyList(firstName, lastName, dateOfBirth, phoneNumber, token);

    if (response) {
      callbackfn(response);
    }
    dispatch({ type: 'GET_SAVED_CUSTOMER_LIST_SUCCESS', payload: response });
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

  } catch (error) {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: 'GET_SAVED_CUSTOMER_LIST_FAILURE', payload: error || 'Saved customer policy service failed. Please try again.' });
  }
};
export const getVehiclePremiumByPolicyIdAction = (policyId, page=0, size=5 ) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token ||sessionStorage.getItem("token");
    const response =  await getVehiclePremiumByPolicyId(token, policyId, page, size)
    dispatch({ type: 'GET_VEHICLE_DETAIL_PREMIUM_BY_ID_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: 'GET_VEHICLE_DETAIL_PREMIUM_BY_ID_FAILURE', payload: error.message || 'All Vehicle premium service failed. Please try again.' });
  }
};

export const setNoteFlag = (data) => (dispatch) => {
  dispatch({ type: START_LOADING, service: 'START_LOADING' });
  dispatch({
    type: 'ADD_NOT_BUTTON_SUCCESS',
    payload: data,
  });
  dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
};

export const getCoverageListingAction = (id,page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'POLICY_LISTING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getCoveragelisting(id,page, size,token);
    dispatch({ type: STOP_LOADING, service: 'POLICY_LISTING' });
    dispatch({ type: "GET_COVERAGE_LIST_SUCCESS", payload: response?.vehicles ?? {}, });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'POLICY_LISTING' });
      dispatch({ type: "GET_PREMIUM_VEHICLES_SUCCESS", payload: error || 'All quote service failed. Please try again.' });
    }
  }
};

export const deleteDriverAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await deleteDriverService(id,token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: "DELETE_DRIVER_SUCCESS", payload: response?.vehicles ?? {}, });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'POLICY_LISTING' });
      dispatch({ type: "DELETE_DRIVER_FAILURE", payload: error || 'Policy driver service failed. Please try again.' });
    }
  }
};


export const deleteVechileAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: STOP_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await deleteVehicleService(id,token);
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    dispatch({ type: "DELETE_VEHICLE_SUCCESS", payload: response?.vehicles ?? {}, });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      dispatch({ type: "DELETE_VEHICLE_FAILURE", payload: error || 'Policy vehicle service failed. Please try again.' });
    }
  }
};

